import { render } from "./politique-de-confidentialitePage.vue?vue&type=template&id=051e2e95"
import script from "./politique-de-confidentialitePage.vue?vue&type=script&lang=js"
export * from "./politique-de-confidentialitePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__